import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasProject } from 'app/shared/model/ainnotateservice/aidas-project.model';
import { getEntities as getAidasProjects } from 'app/entities/ainnotateservice/aidas-project/aidas-project.reducer';
import { getEntity, updateEntity, createEntity, reset } from './aidas-object.reducer';
import { IAidasObject } from 'app/shared/model/ainnotateservice/aidas-object.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasObjectUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasProjects = useAppSelector(state => state.aidasProject.entities);
  const aidasObjectEntity = useAppSelector(state => state.aidasObject.entity);
  const loading = useAppSelector(state => state.aidasObject.loading);
  const updating = useAppSelector(state => state.aidasObject.updating);
  const updateSuccess = useAppSelector(state => state.aidasObject.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-object' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasProjects({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...aidasObjectEntity,
      ...values,
      aidasProject: aidasProjects.find(it => it.id.toString() === values.aidasProjectId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...aidasObjectEntity,
          aidasProjectId: aidasObjectEntity?.aidasProject?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ainnotategwApp.ainnotateserviceAidasObject.home.createOrEditLabel" data-cy="AidasObjectCreateUpdateHeading">
            Create or edit a AidasObject
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? <ValidatedField name="id" required readOnly id="aidas-object-id" label="ID" validate={{ required: true }} /> : null}
              <ValidatedField
                label="Name"
                id="aidas-object-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 3, message: 'This field is required to be at least 3 characters.' },
                  maxLength: { value: 500, message: 'This field cannot be longer than 500 characters.' },
                }}
              />
              <ValidatedField label="Description" id="aidas-object-description" name="description" data-cy="description" type="text" />
              <ValidatedField
                label="Number Of Upload Reqd"
                id="aidas-object-numberOfUploadReqd"
                name="numberOfUploadReqd"
                data-cy="numberOfUploadReqd"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  validate: v => isNumber(v) || 'This field should be a number.',
                }}
              />
              <ValidatedField
                id="aidas-object-aidasProject"
                name="aidasProjectId"
                data-cy="aidasProject"
                label="Aidas Project"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasProjects
                  ? aidasProjects.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-object" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasObjectUpdate;
